import React, { useState } from 'react';
import './TeamDescription.css';
import { Link } from 'react-router-dom';
import { roles } from '../data/roles';
import './TeamDescription.css';

function TeamDescription() {
  const [selectedRole, setSelectedRole] = useState(null);

  const handleRoleClick = (roleId) => {
    setSelectedRole(roleId === selectedRole ? null : roleId);
  };

  const renderRoleGrid = () => (
    <div className="role-grid">
      <div className={`roles-circle desktop-only ${selectedRole ? 'has-selected' : ''}`}>
        <div className="center-globe">
          <img src="img/Team-globe.svg" alt="Team Globe" />
        </div>
        {roles.map(role => (
          <div 
            key={role.id} 
            className={`role-item role-${role.id} ${selectedRole === role.id ? 'selected' : ''}`}
          >
            <div 
              className="role-container" 
              onClick={() => handleRoleClick(role.id)}
            >
              <img className={`${role.id}-show playbook-role`} src={role.image} alt={role.alt} />
              <h3 className="role-title">{role.alt}</h3>
            </div>
            {selectedRole === role.id && (
              <div className="speech-bubble">
                <h3 className="role-tagline">{role.tagline} <br/><br/>   <p> Read more about my <Link to={`/role/${role.id}`} className="view-details-link">responsibilities here</Link> </p></h3>
                
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="roles-grid mobile-only">
        <div className="center-globe">
          <img src="img/Team-globe.svg" alt="Team Globe" />
        </div>
        <div className="roles-grid-container">
          {roles.map(role => (
            <div key={role.id} className="role-grid-item">
              <div
                className={`role-container ${selectedRole === role.id ? 'selected' : ''}`}
                onClick={() => handleRoleClick(role.id)}
              >
                <img className={`${role.id}-show playbook-role`} src={role.image} alt={role.alt} />
                <h3 className="role-title">{role.alt}</h3>
              </div>
              {selectedRole === role.id && (
                <div className="speech-bubble">
                  <h3 className="role-tagline">{role.tagline} <br/><br/>   
                    <p> Read more about my <Link to={`/role/${role.id}`} className="view-details-link">responsibilities here</Link> </p>
                  </h3>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div id="team-description" className="fh5co-features-outer">
      {renderRoleGrid()}
    </div>
  );
}

export default TeamDescription;
